<template>
  <div id="users_list">
    <div class="right div--button ma-2">
      Filtered rows: {{ users_length }}
    </div>

    <b-input-group class="mb-3"
                   prepend="Users registered from - to">
      <b-form-input v-model="createdAtRange.from"
                    aria-label="From"
                    placeholder="YYYY-MM-DD"
                    @keyup.enter="filterUsers"/>
      <b-form-input v-model="createdAtRange.to"
                    aria-label="To"
                    placeholder="YYYY-MM-DD"
                    @keyup.enter="filterUsers"/>
      <b-input-group-append>
        <b-button variant="info"
                  @click="filterUsers">
          Filter by date
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-input-group class="mb-3"
                   prepend="Display only active users">
      <b-form-radio-group v-model="displayOnlyActive"
                          :options="yesNo"
                          button-variant="outline-secondary"
                          buttons
                          class="w-95"/>
    </b-input-group>

    <b-table :current-page="currentPage"
             :fields="fields"
             :items="users"
             :per-page="perPage"
             head-variant="light"
             hover
             outlined
             responsive
             striped>

      <template v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="users"
                         :fields="fields"
                         :not-include-key="['actions', 'ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(created_at)="row">
        {{ formatRegistrationDate(row.item.created_at) }}
      </template>

      <template v-slot:cell(actions)="row">
        <base-icon-button-send title="Go to user details"
                               @click="go_to_user(getId(row.item))"/>
      </template>

    </b-table>

    <b-table-footer v-model="is_busy"
                    :current-page="currentPage"
                    :data-length="users_length"
                    :per-page="perPage"
                    @change-page="change_page">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import BaseIconButtonSend from '@/components/base-components/base-icons/BaseIconButtonSend';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import moment from 'moment';
  import yesNo from '@/json/radioButtonYesNo';

  export default {
    name: 'users_list',
    components: {
      BaseColumnOrdinalNumber,
      BaseIconButtonSend,
      BasePerPageInput,
      ProposalFilter,
      BTableFooter,
    },
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        is_busy: false,
        allUsers: [],
        users: [],
        displayOnlyActive: false,
        yesNo,
        createdAtRange: { from: '', to: '' },
        currentPage: 1,
        perPage: 20,
        id: 1,
      };
    },
    computed: {
      users_length() {
        return this.users.length;
      },
    },
    watch: {
      displayOnlyActive: {
        handler() {
          this.filterUsers();
        },
      },
    },
    created() {
      this.load_data();
    },
    methods: {
      load_data() {
        this.toggle_busy();
        this.axios.get('/users/list')
          .then((response) => {
            this.users = response.data;
            this.users = this.users.map(
              (user) => ({
                ...user,
                created_at: moment(user.created_at, 'YYYY-MM-DD'),
              }),
            );
            this.allUsers = [...this.users];
            this.$emit('setup-proposal', this.users);
            this.toggle_busy();
          });
      },
      setFilterDatesIfEmpty() {
        const from = this.createdAtRange.from === '' ? moment('2018-01-01') : this.createdAtRange.from;
        const to = this.createdAtRange.to === '' ? moment() : this.createdAtRange.to;
        return ([from, to]);
      },
      filterUsersByDate(from, to) {
        return this.allUsers.filter(
          (user) => user.created_at.isBetween(from, to, null, []),
        );
      },
      filterUsersIsActive(users) {
        return users.filter(
          (user) => user.is_active,
        );
      },
      filterUsers() {
        const [from, to] = this.setFilterDatesIfEmpty();
        const usersWithinDateRange = this.filterUsersByDate(from, to);
        let filteredUsers = usersWithinDateRange;
        if (this.displayOnlyActive) {
          filteredUsers = this.filterUsersIsActive(usersWithinDateRange);
        }
        this.$set(this, 'users', filteredUsers);
        this.$emit('setup-proposal-user-filters', this.users);
      },
      toggle_busy() {
        this.is_busy = !this.is_busy;
      },
      go_to_user(user_id) {
        this.$router.push(`/operational/users/${user_id}/0`);
      },
      change_page(val) {
        this.currentPage = val;
      },
      formatRegistrationDate(registrationDate) {
        return moment(registrationDate).format('YYYY-MM-DD');
      },
    },
  };
</script>

<style scoped>
</style>
